import { annotate, annotationGroup } from 'rough-notation';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function setLandingPageScrollTriggers() {
	createScrollTriggerForHighlights();
	createScrollTriggerForTileIcons();
	createScrollTriggerForTileTitles();
}

export function setProfileComponentScrollTriggers() {
	createScrollTriggerForH1s();
	createScrollTriggerForSnapshot();
	createScrollTriggerForTitle();
}

export function footerAnimation() {
	const el = document.querySelector('#footer-link');
	const anim = annotate(el, { type:'circle', color: '#cf3759' });
	return anim
}

export function navAnimation() {
	const el = document.querySelector('#navbar-title');
	const anim = annotate(el, { type:'underline', color: '#76439e', padding: 0, animationDuration: 1500});
	return anim
}

function createScrollTriggerForHighlights() {
	// setup arr for animations
	let animArr = [
		{'name': 'rerc', 'color': '#76439e'},
		{'name': 'stpp', 'color': '#cf3759'},
		{'name': 'soc', 'color': '#ab75ce'},
		{'name': 'lea', 'color': '#f4777f'},
	]

	// for each animation
	animArr.forEach(obj => {
		// grab the el
		obj['el'] = document.querySelector('#' + obj.name);
		// create the animation
		obj['animation'] = annotate(obj['el'], { type: 'highlight', strokeWidth: 5, animationDuration: 2000, color: obj['color'], multiline:true, padding: [5, 15] });

		// bind it to a scroll event
		ScrollTrigger.create({
			trigger: obj['el'],
			start: 'top 66%',
			onEnter: () => { obj['animation'].show() }
		});
	});
}

function createScrollTriggerForTileIcons() {
	// setup arr for animations
	const icon = document.querySelectorAll('.tile-icon')
	icon.forEach((el) => {
		const anim = annotate(el, { type: 'box', strokeWidth: 3, animationDuration: 2000, color: 'white' }); 

		ScrollTrigger.create({
			trigger: el,
			start: 'top 66%',
			onEnter: () => { anim.show() }
		});
	});
}

function createScrollTriggerForTileTitles() {
	// setup arr for animations
	const icon = document.querySelectorAll('.tile-title')
	icon.forEach((el) => {
		const anim = annotate(el, { type: 'underline', strokeWidth: 3, animationDuration: 2000, color: 'white' }); 

		ScrollTrigger.create({
			trigger: el,
			start: 'top 66%',
			onEnter: () => { anim.show() }
			
		})
	});
}

function createScrollTriggerForTitle() {
	// title
	const el = document.querySelector('.profile-title');
	const animation1 = annotate(el, {type:'highlight', animationDuration: 1500, color:'#93003a', multiline:true});

	// subtitle
	const el2 = document.querySelector('.profile-subtitle');
	const animation2 = annotate(el2, {type:'highlight', animationDuration: 1500, color:'#cf3759', multiline:true})

	const ag = annotationGroup([animation1, animation2])
	ag.show();
}

function createScrollTriggerForSnapshot() {
	try {
		const el = document.querySelector('#profile-snapshot-title')
		const an = annotate(el, {type:'underline', strokeWidth: 5, 
			animate:false, color: '#76439e'})
		an.show();
	} catch {
		console.log('no ScrollTrigger and RoughAnnotation for snapshot')
	}
}

function createScrollTriggerForH1s() {
	let animArr = [
		{'name': 'about-title', 'color': '#f4777f'},
		{'name': 'staff-title', 'color': '#cf3759'},
		{'name': 'academics-title', 'color': '#76439e'},
		{'name': 'discipline-title', 'color': '#93003a'},
		{'name': 'crime-title', 'color': '#43146b'}
	]

	// for each animation
	animArr.forEach(obj => {

		try {
			// grab the el
			obj['el'] = document.querySelector('#' + obj.name);
			
			// create the animation
			obj['animation'] = annotate(obj['el'], { type: 'underline', strokeWidth: 3, animationDuration: 1500, color: obj['color'], multiline:true });

			// bind it to a scroll event
			ScrollTrigger.create({
				//markers: true,
				trigger: obj['el'],
				start: 'top 66%',
				onEnter: () => { obj['animation'].show() }
			});
		} catch {
			console.log(obj)
		}
	});
}